import styled from 'styled-components';
import { BOX_SHADOW, PRIMARY, SECONDARY } from '../../const/colors';
import { mobile_medium, mobile_normal, mobile_title } from '../../const/fonts';

export const Container = styled.div`
	background-color: ${SECONDARY};
	border: 1px solid ${PRIMARY};
	text-align: end;
	position: relative;
  padding-bottom: 3rem;
  min-width:800px;
  @media screen and (max-width: 1600px) {
    padding-bottom: 1rem;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
		height: 100vh;
    padding-top: 4rem;
    padding-bottom: 0;
    border: none;
    overflow-y: hidden;
    min-width: initial;
  }
  @media screen and (max-height: 700px) {
    padding-bottom: 0;
  }
`;
export const ButtonClose = styled.button`
	border: none;
	background-color: #fff;
	color: ${SECONDARY};
	padding: 0.5rem;
	cursor: pointer;
	transition: background-color 0.3s ease-in-out;
	svg {
		font-size: 2.3rem;
	}
	&:hover {
		background-color: #93291E;
		svg {
			color: #fff;
		}
	}

	@media screen and (max-width: 1600px) {
		padding: 0.1rem;
	}

	@media screen and (max-width: 768px) {
		display: inline-block;
		position: absolute;
		top: 5rem;
		right: 10px;
		z-index:1;
	}
`;

export const ModalTitle = styled.div`
  text-align: center;
  color: #fff;
  font-size: 2rem;
  font-weight: bold;

  @media screen and (max-width: 2000px) {
    font-size: 1.5rem;
  }
  @media screen and (max-width: 1400px) {
    font-size: 1.2rem;
  }
  @media screen and (max-width: 768px) {
    font-size: ${mobile_title};
    padding: 1rem 0;
    border-top: 10px solid ${PRIMARY};
  }
`;

export const Form = styled.form`
  width: 100%;
	display: flex;
	flex-direction: column;
	text-align: initial;
	align-items: center;
	padding: 2rem 4rem;
	position: relative;

  @media screen and (max-width: 1400px) {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  @media screen and (max-width: 768px) {
    padding-top: 1rem;
    background-color: ${SECONDARY};
    height: calc(90%);

    overflow-y: scroll;
  }
  @media screen and (max-width: 480px) {
    padding: 2rem;
    padding-top: 0;
    height: calc(90%);
  }

`;

export const InputContainer = styled.div`
	position: relative;
  flex:1;
	width: 100%;
  margin: 0.5rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
	> input {
		border: 1px solid ${PRIMARY};
		outline: none;
		background-color: transparent;
		color: #888;
		padding: 0.7rem 1rem;
		font-size: 1rem;
		width: 100%;
    transition: all 0.3s ease;
	}
  input {
    color:  #fff;
  }
  > input.error {
    border-color: #C21010;
  }
	 label {
    font-size: 1rem;
		padding: 0 1rem;
    font-weight: bold;
		color: #fff;
	}

  input.hide {
    opacity: 0;
    visibility: hidden;
  }
  input.show {
    opacity: 1;
    visibility: show;
  }

  .MuiFormControlLabel-label {
    font-size: 1rem;
    font-family: "Gotham";
    letter-spacing: 0;
    line-height: normal;
    font-weight: bold;
  }

	&:hover {
		input {
			border-color: #fff;
		}
	}

  @media screen and (max-width: 2000px) {
	  width: 100%;
    input, .MuiFormControlLabel-label {
      font-size: 0.8rem;
      margin: 0.2rem 0;
    }
  }
  @media screen and (max-width: 1600px) {
    margin: 0.25rem 1rem;
  }
  @media screen and (max-width: 768px) {
    align-items: center;
    input, label,.MuiFormControlLabel-label {
      font-size: ${mobile_normal};
    }
    margin: 1rem auto;
    text-align: center;
    input::placeholder {
      text-align: center;
    }
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
	  flex-direction: column;
  }
`;

export const CheckBoxContainer = styled.div`
  flex:1;
  display: flex;
  flex-direction: column;
  color: #fff;
  margin: 1rem;
  width: 100%;
  label.form-control {
    display: grid;
    align-items: center;
    grid-template-columns: 1.2em auto;
    gap: 0.5em;
    margin: 0.5rem;
    font-size: 1rem;
    width: 100%;
  }
  a {
    transition: color 0.3s ease;
  }
  a:hover {
    color: ${PRIMARY};
  }
  @media screen and (max-width: 2000px) {
    label.form-control {
      font-size: 0.7rem;
    }
  }
  @media screen and (max-width: 1600px) {
    margin: 0.25rem 1rem;
  }
  @media screen and (max-width: 768px) {
    label.form-control {
      font-size: ${mobile_medium};
    }
    margin: 1rem 0;
    span{
      padding-left:1rem;
    }
  }
`;

export const Button = styled.button`
	width: 60%;
	font-size: 1.1rem;
  font-weight: bold;
	border: none;
  background-color: ${PRIMARY};
  color: ${SECONDARY};
  box-shadow: ${BOX_SHADOW};
  padding: 1rem;
	margin-top: 1.5rem;
  cursor: pointer;
  transition: all .3s ease-in-out;
  
  &:hover:not(:disabled){
    background-color: #fff;
  }

  &:disabled {
    box-shadow: none;
    cursor:progress;
    opacity: 0.8;
  }
  @media screen and (max-width: 2000px) {
    font-size: 0.9rem;
    padding: 0.7rem;
  }
  @media screen and (max-width: 1600px) {
    font-size: 0.8rem;
	  margin-top: 0.5rem;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
	  font-size: ${mobile_normal};
  }
`;
export const ButtonStep = styled.button`
  width: 40%;
	font-size: 1.1rem;
  font-weight: bold;
	border: none;
  background-color: ${PRIMARY};
  color: ${SECONDARY};
  box-shadow: ${BOX_SHADOW};
  padding: 1rem;
	margin-top: 1.5rem;
  cursor: pointer;
  transition: all .3s ease-in-out;
  text-align:center;
  &:hover:not(:disabled){
    background-color: #fff;
  }
  &.hidden{
    display:none;
  }
  &:disabled {
    box-shadow: none;
    opacity: 0.8;
  }
  &.btnvolver{
    background:#93291e;
    color:white;
    box-shadow: #93291e 0px 0px 14px;
    &:hover{
      color: ${SECONDARY};
    }
  }

  @media screen and (max-width: 2000px) {
    font-size: 0.9rem;
    padding: 0.7rem;
  }
  @media screen and (max-width: 1600px) {
    font-size: 0.8rem;
	  margin-top: 0.5rem;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
	  font-size: ${mobile_normal};
  }
`
export const InputConfirmPass = styled.input`
    border: 1px solid ${PRIMARY};
    color:  #fff;
		outline: none;
		background-color: transparent;
		color: #888;
		padding: 0.7rem 1rem;
		font-size: 1rem!important;
		width: 100%;
    transition: all 0.3s ease;
    text-align: justify;
    &:hover {
      input {
        border-color: #fff;
      }
    }
    &.error {
      border-color: #C21010;
    }
    &.correct {
      border-color: #28a745;
    }
    @media screen and (max-width: 768px) {
      font-size: ${mobile_normal}!important;
      margin: 0.8rem auto;
      color:white;
      text-align:justify;
      font-weight: bold;
      &::placeholder {
        text-align: justify!important;
      }
  }
`
export const WarningPass = styled.div`
  display:inline-flex;
  align-items: center;
  font-size: 10px;
  color: #fff;
  margin-left: 5px;
  svg {
    font-size: 1rem;
    color: #C21010;
    margin-right: 5px;
  }
`
export const ButtonCancel = styled(Button)`
  background-color: #C21010;
  color: #fff;
  box-shadow: none;
`;

export const InputCL = styled.div`
flex: 1;
display: flex;
margin-top: 0.5rem;
>div {
  margin: 0;
}

`

export const Guion = styled.span`
 color: white; 
 font-size: 2rem;
  margin: auto 0.2rem;

  @media screen and (max-width: 768px) {
    margin-top: 2.5rem;
  }
`